import axios from 'axios';
import ConfigConnection from '../config/config.service';
export default class PercentileService{
  // API Instance
  configConnection: any = new ConfigConnection();

  get(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}skill`, config);
  }

  create(user){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.post(`${_.configConnection.apiInstance}user`, user, config);
  }

  edit(user, user_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.put(`${_.configConnection.apiInstance}user/${user_id}`, user, config);
  }

  getById(user_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}user/${user_id}`, config);
  }

  delete_user(user_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.delete(`${_.configConnection.apiInstance}user/${user_id}`, config);
  }

  getRoles(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}role`, config);
  }

  getCompanies(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}company`, config);
  }

  assingRol(user_id, role_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.post(`${_.configConnection.apiInstance}user/${role_id}/role`, {roleId: role}, config);
  }

  assingCompanies(user_id, company_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.post(`${_.configConnection.apiInstance}user/${user_id}/company`, {companyId: company_id}, config);
  }

  getInactive(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}user/inactive`, config);
  }

  active_user(user_id, reactivate){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}user/${user_id}/reactivate`, config);
  }
}
